import React, { useEffect } from 'react'
import tick from "../../assets/images/tick.png"

const Certifications = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    useEffect(() => {
        scrollToTop();
    }, []);
    return (
        <div>
            <section className="bg-mwhite dark:bg-gray-900 m-5 mt-20 lg:m-10" id='certificate'>
                <div className="grid px-4 py-8 mx-auto lg:gap-20 xl:gap-20 lg:py-20 lg:grid-cols-12">
                    <div className="mr-auto place-self-center lg:col-span-6">
                        <h2 className=" mb-4 lg:text-4xl text-3xl
                        font-extrabold text-mcolor font-mfont
                             dark:text-white">
                            Verify your Making Minds Technologies certifications.
                        </h2>
                        <p className="mt-5 mb-6 text-mcolor 
                            lg:mb-8 font-semibold font-mfont md:text-lg lg:text-xl dark:text-gray-400">
                            All our certified developers and students have a unique certification code assigned
                            to them upon successful completion of the course.
                            You can enter it in the box below to view and validate all their relevant details.
                        </p>
                    </div>
                    <div className=" lg:mt-0 lg:col-span-6 lg:flex">
                        <div className="rounded-3xl border border-gray-200
                         bg-mwhite dark:bg-gray-800 dark:border-gray-700 shadow-2xl
                          shadow-gray-600/10 ">
                            <div className="p-8 py-10 sm:p-20 justify-center text-center">
                                <div className="flex justify-center flex-row">
                                    <img src={tick} alt='tick' className='h-20 mb-5' />
                                </div>
                                <form action="" className="space-y-2 justify-center text-center">
                                    <div className="space-y-5 mb-5">
                                        <label for="certi" className="text-mblack font-bold font-mfont lg:text-2xl text-xl dark:text-gray-300">Enter your Certification Code</label>
                                        <input
                                            type="text"
                                            name="certi"
                                            id="certi"
                                            className="focus:outline-none block w-full rounded-md border
                                             border-gray-200 dark:border-gray-600 bg-transparent
                                              px-4 py-3 text-mblack transition duration-300 focus:ring-2 "
                                        />
                                        <p className='text-center justify-center font-mfont font-medium'>Please enter your Certification code, exactly as it appears on your certificate.</p>
                                    </div>
                                    <button type="submit" className="relative 
                                     flex h-11 w-full items-center justify-center px-6 
                                     font-medium  text-white rounded-sm bg-mcolor  hover:opacity-75  
                                     focus:ring-gray-300 active:opacity-[0.85]
                                     focus:ring-4 focus:ring-primary-300 dark:focus:ring-primary-900
                                       hover:bg-mblack">
                                        <span className="relative font-mfont text-base uppercase font-semibold text-white
                                         dark:text-dark">submit</span>
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        </div>
    )
}

export default Certifications